export const useViteEnvironment = () => {
  const isDev = import.meta.env.MODE === 'development'
  const isProd = import.meta.env.VITE_ENV === 'production'
  const isTest = import.meta.env.VITE_ENV === 'test'

  return {
    isDev,
    isProd,
    isTest,
  }
}
